import React from "react";
import { Color, Flex, HorizontalDivider, Text } from "src/elements";
import { OTouchedMark } from "./OTouched";

interface Props {
  title: string;
  area: string;
  isDisabled?: boolean;
  children: React.ReactNode;

  path?: string | readonly string[];
}

export const RulesSectionContainer = ({ title, area, isDisabled, children, path }: Props) => (
  <Flex
    width="100%"
    background={Color.lightGray}
    column
    borderRadius="3px"
    overflow="hidden"
    gridArea={area}
  >
    <Flex
      background={Color.lightGrayHover}
      padding="5px 10px"
      justify="center"
      align="center"
      gap="10px"
    >
      <Text variant="body1" color={(isDisabled && Color.textDisabled) || Color.textMain}>
        {title}
      </Text>
      <OTouchedMark path={path} />
    </Flex>

    <HorizontalDivider color={Color.textDisabled} />

    <Flex column padding="10px" gap="10px">
      {children}
    </Flex>
  </Flex>
);
